import type { ColorKey } from '@iheartjane/reefer';
import type { ProductCategory } from '@iheartjane/types';

export const getCategoryTagColor = (category: ProductCategory): ColorKey => {
  switch (category) {
    case 'cbd':
      return 'palm';
    case 'sativa':
      return 'emerald';
    case 'indica':
      return 'grape';
    case 'hybrid':
      return 'grays-dark';
    default:
      return 'grays-dark';
  }
};
